import { Injectable } from '@angular/core';
import { Money } from '../models/money.model';

@Injectable()
export class MoneyService {
  sum(prices?: Array<Money | null>): { sum: Money; error?: string } {
    const sumWithError: Money = {
      value: null,
      currencyCode: null,
      currencySymbol: null,
      fractionalDigits: null,
      formattedValue: null
    };

    if (prices == null) {
      return { sum: sumWithError, error: 'No prices provided' };
    }

    if (prices.some((price) => price == null)) {
      return { sum: sumWithError, error: 'One of the prices is null' };
    }

    if (
      !prices.every(
        (price) =>
          price?.value != null &&
          price?.currencyCode != null &&
          price?.currencySymbol != null &&
          price?.fractionalDigits != null
      )
    ) {
      return { sum: sumWithError, error: 'Not all prices have all the required info' };
    }

    const priceItem = prices[0];
    const currencyCode = priceItem?.currencyCode;
    const currencySymbol = priceItem?.currencySymbol;
    const fractionalDigits = priceItem?.fractionalDigits;

    if (!prices.every((price) => price?.currencyCode === currencyCode)) {
      return { sum: sumWithError, error: 'Not all prices are in the same currency' };
    }

    let totalValue = 0;
    for (const price of prices) {
      if (price?.value != null) {
        totalValue += price.value;
      }
    }

    const sum: Money = {
      value: totalValue,
      currencyCode: currencyCode ?? null,
      currencySymbol: currencySymbol ?? null,
      fractionalDigits: fractionalDigits ?? null,
      formattedValue: null
    };

    sum.formattedValue = this.getFormattedValue(sum);

    return { sum };
  }

  getFormattedValue(money: Money): string | null {
    if (money == null) {
      return null;
    } else {
      const digits = money.fractionalDigits ?? 0;
      const formattedNumber = money.value?.toFixed(digits) ?? '0';
      const symbol = money.currencySymbol === money.currencyCode ? '' : money.currencySymbol;
      return `${symbol}${formattedNumber} ${money.currencyCode}`;
    }
  }
}
